import { render } from "./PrivacyScore.vue?vue&type=template&id=2bd9b5ea&scoped=true"
import script from "./PrivacyScore.vue?vue&type=script&lang=js"
export * from "./PrivacyScore.vue?vue&type=script&lang=js"

import "./PrivacyScore.vue?vue&type=style&index=0&id=2bd9b5ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd9b5ea"]])

export default __exports__